import { Subject } from 'rxjs/Subject';

export class NavigationService {
  private createStart = new Subject();
  public createAnnounced = this.createStart.asObservable();

  private stepChanged = new Subject<number>();
  public stepChangedAnnounced = this.stepChanged.asObservable();

  publishCreateStarted() {
    this.createStart.next();
  }

  publishStepChanged(stepNumber: number) {
    this.stepChanged.next(stepNumber);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/navigation.service.ts